<template>
    <div class="lotti-home-container">

      <div class="lotti-grid-row lotti-grid-row-small lotti-grid-reverse-order">

        <div class="lotti-grid-col lotti-grid-col-33">
          <report-module></report-module>
        </div>

        <div class="lotti-grid-col lotti-grid-col-33 lotti-grid-swap-target">
          <stats-module></stats-module>
        </div>

        <div class="lotti-grid-col lotti-grid-col-33 lotti-grid-mini">
          <therapist-module></therapist-module>
        </div>

        <div class="lotti-grid-col lotti-grid-col-33 lotti-grid-mini">
          <tracker-module></tracker-module>
        </div>

        <div class="lotti-grid-col lotti-grid-col-33 lotti-grid-swap-helper">
          <!-- BUGFIX ugly workaround, because I did not use flex boxes in the first place. fail-->
        </div>

      </div>

      <div class="lotti-grid-row lotti-grid-row-mid">

        <div class="lotti-grid-col lotti-grid-col-50">
          <my-children-module></my-children-module>
        </div>
        <div class="lotti-grid-col lotti-grid-col-50">
          <my-sessions-module v-if="renderMySession"></my-sessions-module>
        </div>
      </div>

      <!--slot for to desplay pie-charts-->
      <!--
      <div class="lotti-grid-row lotti-grid-row-small">
        <div class="lotti-grid-col lotti-grid-col-100">
        </div>
      </div>
      -->

    </div>
</template>


<script>
    import Vue, {VueInstance} from '../../main.js';
    import auth from '../../auth.js';

    //loading modules for dashboard-tiles
    import TherapistModule from '../modules/Therapist';
    import ReportModule from '../modules/Report';
    import StatsModule from '../modules/Stats';
    import TrackerModule from '../modules/Tracker';
    import MyChildrenModule from '../modules/MyChildren';
    import MySessionsModule from '../modules/MySessions';


    export default {

        data() {
            return {
                auth: auth,
                renderMySession: true,
            }
        },

        methods: {

          resetAndReloadTableOnEvent() {
            this.renderMySession = false;
            this.$nextTick(() => {
              this.renderMySession = true;
            });
          }
        },

        mounted() {
          //event fired from therapistManagement.vue when this component should update its data
          VueInstance.$on('createdSession', this.resetAndReloadTableOnEvent);
        },

        beforeDestroy() {
          VueInstance.$off('createdSession', this.resetAndReloadTableOnEvent);
        },

        created() {

        },

        components: {
          TherapistModule: TherapistModule,
          ReportModule: ReportModule,
          MyChildrenModule: MyChildrenModule,
          MySessionsModule: MySessionsModule,
          TrackerModule: TrackerModule,
          StatsModule: StatsModule,
        }
    }

</script>